import Radio from './radio';
import Group from './group';
import Button from './radioButton';
Radio.Button = Button;
Radio.Group = Group;
export { Button, Group };
export default Radio;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/radio/index.js
// module id = 151
// module chunks = 3